<template>
  <h1>Detail Branch {{ $route.params.id }}</h1>
</template>

<script>
export default {};
</script>

<style></style>
